// Skeleton loaders for the collection grid during filter AJAX updates.
// Horizon dispatches a bubbling 'filter:update' event (ThemeEvents.FilterUpdate)
// synchronously before it runs the view-transition + morph. Swapping the grid's
// children for skeletons here makes them the transition's "before" frame, so they
// crossfade to the real products once the morph completes.

const SKELETON_COUNT = 9; // 3 rows x 3 columns on desktop

function buildSkeleton() {
  const li = document.createElement('li');
  li.className = 'product-grid__item intuition-skeleton';
  li.setAttribute('aria-hidden', 'true');
  li.innerHTML =
    '<div class="intuition-skeleton__card">' +
      '<div class="intuition-skeleton__image"></div>' +
      '<div class="intuition-skeleton__body">' +
        '<span class="intuition-skeleton__line intuition-skeleton__line--title"></span>' +
        '<span class="intuition-skeleton__line intuition-skeleton__line--price"></span>' +
        '<span class="intuition-skeleton__line intuition-skeleton__line--button"></span>' +
      '</div>' +
    '</div>';
  return li;
}

document.addEventListener('filter:update', () => {
  const grid = document.querySelector('.intuition-collection [ref="grid"]');
  if (!grid) return;
  const skeletons = Array.from({ length: SKELETON_COUNT }, buildSkeleton);
  grid.replaceChildren(...skeletons);
});
